module.exports = __webpack_public_path__ + "media/Fs.a50f62f4.wav";